import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { injectIntl } from "react-intl"
import { useQuery } from "react-query"
import LoadingSpinner from "../common/spinner/loading.component"
import AccountService from "../state/account/service"
import IntlProps from "../state/helpers/IntlProps"
import QMPaymentOnboardingSetup from "./QMPaymentOnboardingSetup"
import StripeOnboardingSetup from "./StripeOnboardingSetup"

type Props = {
    onStepCompleted: (payload: unknown) => void
    continue?: boolean
}

const PaymentSetupWrapper = (props: Props & IntlProps) => {

    const {data: account} = useQuery(["account"], () => AccountService.get(AppContext.getAccount().id))

    if (!account) {
        return <LoadingSpinner/>
    }

    if (account.hasUSDCurrency() && !account.hasShopifyIntegrationKey()) {
        return <QMPaymentOnboardingSetup
            onStepCompleted={props.onStepCompleted}
        />
    }

    return <StripeOnboardingSetup
        onStepCompleted={props.onStepCompleted}
        continue={props.continue}
    />

}

export default injectIntl(PaymentSetupWrapper)


// WEBPACK FOOTER //
// ./src/onboarding/PaymentSetupWrapper.tsx